import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import config from '@/config';
const { API_URL } = config;

export const fetchProducts = createAsyncThunk('products/fetch', async (paginationParams) => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/products?${new URLSearchParams(paginationParams).toString()}`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.log(error);
    return {};
  }
});

const productsSlice = createSlice({
  name: 'products',
  initialState: {
    items: [],
    counts: 0,
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        if (action.payload.code === 200) {
          state.status = 'succeeded';
          state.items = action.payload?.data?.items ?? [];
          state.counts = action.payload?.data?.counts ?? 0;
          state.error = null;
        } else {
          state.status = 'failed';
          state.error = action.payload.message;
        }
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default productsSlice.reducer;
